import IssueLogEmpty from '@/ui/pages/issue/IssueLogEmpty.vue';
import { defineComponent, h, ref } from 'vue';
import { ActivityLogs } from '@/ui/components/activityLogs/ActivityLogs';
import { user } from '@/ui/auth/auth';
import { t } from '@/ui/i18n/i18n';
import { useIssueActivities } from '@/ui/pages/issue/useIssueActivities';
import { IssueActivities } from '@/entities/activity/constants';
import { Activities as ActivitiesCodecs, ActivityComment } from '@/entities/activity/model';
import { LogIssueCreator } from '@/ui/components/activityLogs/factory/LogIssueCreator';

export const IssueCreatePageLogs = defineComponent({
  name: 'IssueCreatePageLogs',
  setup(_, context) {
    const logs = ref<ActivitiesCodecs[]>([]);

    const { valuesTranslation, fieldsTranslation } = useIssueActivities();

    const createNewComment = (comment: string): ActivityComment => ({
      type: 'comment',
      activity: IssueActivities.CommentAdded,
      // @ts-ignore
      createdAt: Math.round(new Date().getTime() / 1000),
      user: { id: user.value!.id, name: user.value!.name, data: { name: user.value!.name } },
      payload: { comment },
    });

    const onLogCommentCreated = (comment: string) => {
      // @ts-ignore
      logs.value = [createNewComment(comment), ...logs.value];
      context.emit('comment:add', comment);
    };

    return function render() {
      return h(ActivityLogs, {
        props: {
          valuesTranslation,
          fieldsTranslation,
          logs: logs.value,
          showCreateComment: true,
          resourceName: t('common.issue').toLowerCase(),
          componentCreator: new LogIssueCreator(),
        },
        on: { 'comment:created': onLogCommentCreated },
      }, logs.value.length === 0
        ? [
          h(IssueLogEmpty, { slot: 'afterList', class: 'create-edit-issue-page__empty-log' }),
        ] : null);
    };
  },
});
